import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

async function bootstrap() {
  // MSW só no navegador e só com VITE_MOCK=1 (`pnpm dev:mock`).
  if (import.meta.env.VITE_MOCK === '1') {
    const { startMockWorker } = await import('./mocks/browser');
    await startMockWorker();
  }

  const container = document.getElementById('root');
  if (!container) throw new Error('#root não encontrado no index.html');

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
